export default __webpack_public_path__ + "static/media/CL125_SE.2e5553c2.jpg";